import { render, staticRenderFns } from "./BaoZ.vue?vue&type=template&id=2182908c"
import script from "./BaoZ.vue?vue&type=script&lang=js"
export * from "./BaoZ.vue?vue&type=script&lang=js"
import style0 from "./BaoZ.vue?vue&type=style&index=0&id=2182908c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports